<template>
    <div class="results-page" v-if="this.user">
        <a class="skip-main" href="#main">Skip to main content</a>
        <div class="bg-light py-3">
            <div class="container">
                <div class="row justify-content-center">
                    <div>
                        <b-button @click="showRecent" class="mr-2 recent-saved" :class="{'active': recent === true}">Recent</b-button>
                        <b-button @click="showSaved" class="mr-2 recent-saved" :class="{'active': saved === true}">Saved</b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-4" v-if="this.recent">
            <div class="row results" id="main" role="main">
                <div class="col-12 mb-3"><p>Select a journey to plan again</p></div>
                <RecentJouney></RecentJouney>
            </div>
        </div>
        <div class="container mt-4" v-if="this.saved">
            <div class="row results" id="main" role="main">
                <div class="col-12 mb-3"><p>Select a journey to view details</p></div>
                <SavedJourney ></SavedJourney>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState,
} from 'vuex'

import RecentJouney from './RecentJourney.vue'
import SavedJourney from './SavedJourney.vue'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Saved',
    components: {
        RecentJouney,
        SavedJourney,

    },
    data() {
        return {
            name: whitelabel.brand,
            recent: true,
            saved: false,
        }
    },
    computed: {
        ...mapState([
            'user',
        ]),
    },
    methods: {

        showRecent() {
            if (!this.recent) {
                this.recent = true
                this.saved = false
            }
        },
        showSaved() {
            if (!this.saved) {
                this.recent = false
                this.saved = true
            }
        },
    },

}
</script>
<style lang="scss">
    .results-page {
        .active{
            background-color: #BECD47 !important;
            border-color: #BECD47 !important;
        }
    }
</style>
